import { Avatar, Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../css/dashboard.css";
import "../css/setting.css";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import { roles } from "../firebase.collection";
import {
  doc,
  documentId,
  onSnapshot,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { showCustomToast } from "../component/Misc/CustomToast";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import { getRoleColor } from "../utils/roleColors";

export default function AccountContentMobile() {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userRole, setUserRole] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [phoneNumberUpdateInProgress, setPhoneNumberUpdateInProgress] =
    useState(false);

  const { currentUser, logOut } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";

  useEffect(() => {
    if (!currentUser) {
      console.log("No user id");
      return undefined;
    }

    return queryRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  function queryRole() {
    return onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;
          const phone = doc.data().phoneNumber;
          setUserRole(role);
          setPhoneNumber(phone || "");
        } else {
          console.log("Cloud function will be deployed");
        }
      }
    );
  }

  function updateRole() {
    const roleRef = doc(db, "roles", userIdState);
    const originalPhoneNumber = phoneNumber;
    setIsActive(false);
    setPhoneNumberUpdateInProgress(true);
    setDoc(roleRef, { phoneNumber: originalPhoneNumber }, { merge: true })
      .then(() => {
        showCustomToast("Phone number updated successfully", "success");
      })
      .catch((error) => {
        console.error("Error updating phone number: ", error);
      })
      .finally(() => {
        setIsActive(true);
        setPhoneNumberUpdateInProgress(false);
      });
  }

  const email = currentUser ? currentUser.email : "";
  const displayedName = currentUser ? currentUser.displayName : "";
  const photoUrl = currentUser ? currentUser.photoURL : "";
  const roleColor = getRoleColor(userRole);

  async function handleLogout() {
    setError("");
    try {
      await logOut();
      showCustomToast(`User ${currentUser.email} successfuly logged out`, "success");
      navigate("/login");
    } catch {
      setError("Failed to logout");
      console.log("Error", error);
    }
  }

  return (
    <div className="right-container-settings-mobile">
      <TopTitleBannerMobile title={"Settings"} />
      <div className="account-settings-shell account-settings-shell-mobile">
        <section className="account-summary-panel">
          <Avatar src={photoUrl} className="account-avatar" />
          <div className="account-summary-copy">
            <div className="account-section-kicker">Profile</div>
            <h2>{displayedName || "User profile"}</h2>
            <p>{email}</p>
          </div>
          <div className="account-role-chip" style={{ background: roleColor }}>
            {userRole || "Role loading"}
          </div>
        </section>

        <section className="account-section-panel">
          <div className="account-section-header">
            <div>
              <div className="account-section-title">Personal details</div>
              <div className="account-section-subtitle">
                Email and display name are managed by your Google account.
              </div>
            </div>
          </div>

          <div className="account-fields-grid">
            <label className="account-field">
              <span>Email</span>
              <input className="account-input is-readonly" value={email} readOnly />
            </label>

            <label className="account-field">
              <span>Display name</span>
              <input
                className="account-input is-readonly"
                value={displayedName || ""}
                readOnly
              />
            </label>

            <label className="account-field">
              <span>Phone number</span>
              <input
                className="account-input"
                value={phoneNumber || ""}
                placeholder="Add a phone number"
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </label>
          </div>
        </section>

        <section className="account-section-panel account-role-panel">
          <div>
            <div className="account-section-title">Assigned role</div>
            <div className="account-section-subtitle">
              This role controls which parts of the system you can access.
            </div>
          </div>
          <div className="account-role-chip large" style={{ background: roleColor }}>
            {userRole || "Role loading"}
          </div>
        </section>

        <div className="account-actions-bar">
          <Button
            variant="outlined"
            color="error"
            onClick={handleLogout}
            className="account-logout-button"
          >
            Log out
          </Button>
          <Button
            variant="contained"
            onClick={updateRole}
            disabled={!isActive}
            className="account-save-button"
          >
            {phoneNumberUpdateInProgress ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Save changes"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
